import { Occurrence, SupportedUtms } from '@shared/types';
import { PARAMS_TO_CAPTURE, getUtms } from '../../hooks/useUtms';
import { getParentWindowURL } from '../../hooks/useParentWindowURL';
import { PublicCourse, PublicEducator } from '@cademy-package/sdk-component-types';

type GetBookingUrlProps = {
    courseSlug: PublicCourse['slug'];
    courseType: PublicCourse['type'];
    educatorSlug: PublicEducator['slug'];
    isEmbed: boolean;
    occurrenceId?: Occurrence['_id'];
    isRequest?: boolean;
    isGroup?: boolean;
    location?: string | null;
};
export const getBookingUrl = ({
    courseSlug,
    courseType,
    educatorSlug,
    isEmbed,
    occurrenceId,
    isRequest,
    isGroup,
    location,
}: GetBookingUrlProps): string => {
    const searchParams = new URLSearchParams({
        educator: educatorSlug,
        course: courseSlug,
    });

    if (occurrenceId) {
        searchParams.set('occurrence', occurrenceId);
    }

    if (isRequest === true && courseType !== 'on-request') {
        searchParams.set('request', 'true');
    }
    if (isGroup === true && courseType !== 'on-request') {
        searchParams.set('request_type', 'group');
    }

    if (location) {
        searchParams.set('location', location);
    }

    if (isEmbed === false) {
        return `/checkout?${searchParams.toString()}`;
    }

    searchParams.set('origin', 'embed');
    const parentWindowUrl = getParentWindowURL();
    searchParams.set('parent_window_url', encodeURIComponent(parentWindowUrl));
    const utms = getUtms();
    Object.entries(utms || {}).forEach(([key, value]) => {
        if (PARAMS_TO_CAPTURE.includes(key as SupportedUtms)) {
            searchParams.set(key, value);
        }
    });

    const [protocol, host] = (process.env.NEXT_PUBLIC_MARKETPLACE_URL || '').split('://');
    return `${protocol}://${educatorSlug}.${host}/checkout?${searchParams.toString()}`;
};
